const fuzzball = require('fuzzball')
const { sqlValue } = require('./addressExtra')

class RKA {
    static atsTypes = [ 1, 2, 4, 6, 9, 37, 38, 49, 55, 56, 65, 69, 70, 73 ]
    static strTypes = [ 11, 12, 13, 14, 15, 16, 17, 19, 20, 21, 24, 25, 27, 33, 35, 50, 61, 71, 78, 79, 103, 105 ]
    static buildingTypes = [ 1, 2, 3, 4, 5, 6, 7, 8 ]
    static roomTypes = [ 1, 2, 6, 3, 4, 7, 8, 9, 11 ]

    constructor() {}

    async getStreets(city) {
        let children = await db.execute('SELECT id FROM rka_ats WHERE parent_id = ?', [city])
        let atsIds = [+city]
        for(let ch of children) {
            atsIds.push(ch.id)
        }
        // console.log('atsIds', atsIds)

        let streets = await db.execute(`SELECT
                rg.id,
                rt.title,
                rt.short_title AS short_title,
                rg2.name_rus AS parent,
                rt2.title as parent_title,
                rt2.short_title as short_parent_title,
                rg.name_rus,
                rg.name_kaz,
                rg.full_path_rus,
                rg.full_path_kaz,
                rg.ats_id,
                rg.geonim_type,
                rg.rco
            FROM rka_geonims rg
            LEFT JOIN rka_geonims rg2 ON rg.parent_id = rg2.id
            JOIN rka_types rt ON rg.geonim_type = rt.type_id AND rt.table_name = 'geonims'
            LEFT JOIN rka_types rt2 ON rg2.geonim_type = rt2.type_id AND rt.table_name = 'geonims'
            -- WHERE rg.geonim_type IN (${RKA.strTypes}) AND rg.ats_id IN (${atsIds.join(', ')})
            WHERE rg.ats_id IN (${atsIds.join(', ')})
            GROUP BY rg.geonim_type, rg.parent_id, rg.name_rus
            ORDER BY rg.name_rus`)

        for(let street of streets) {
            street.text = `${street.parent ? `${street.parent_title} ${street.parent}, ` : ''}${street.title} ${street.name_rus}`
        }

        return streets
    }

    static async getFullAddress(obj) {
        let fullAddr = false

        if(obj.city && obj.street && obj.building && obj.buildingPart) {
            fullAddr = await db.execute(`SELECT
                    rbp.id,
                    rt.title,
                    rt.short_title AS short_title,
                    rbp.number,
                    rbp.full_path_rus,
                    rbp.full_path_kaz,
                    rbp.building_id,
                    rbp.room_type,
                    rbp.rca
                FROM rka_building_parts rbp
                JOIN rka_types rt ON rbp.room_type = rt.type_id AND rt.table_name = 'building_parts'
                WHERE rbp.room_type IN (${RKA.roomTypes}) AND rbp.id = ?
                AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))`, [ obj.buildingPart ])
        } else if(obj.city && obj.street && obj.building) {
            fullAddr = await db.execute(`SELECT
                    rb.id,
                    rt.title,
                    rt.short_title AS short_title,
                    rb.number,
                    rb.full_path_rus,
                    rb.full_path_kaz,
                    rb.d_buildings_pointer_id,
                    rb.rca
                FROM rka_buildings rb
                JOIN rka_types rt ON rb.d_buildings_pointer_id = rt.type_id AND rt.table_name = 'buildings'
                WHERE rb.d_buildings_pointer_id IN (${RKA.buildingTypes}) AND rb.id = ?
                AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))`, [ obj.building ])
        } else if(obj.city && obj.street) {
            fullAddr = await db.execute(`SELECT
                    rg.id,
                    rt.title,
                    rt.short_title AS short_title,
                    rg.name_rus,
                    rg.full_path_rus,
                    rg.full_path_kaz,
                    rg.geonim_type,
                    rg.rco
                FROM rka_geonims rg
                JOIN rka_types rt ON rg.geonim_type = rt.type_id AND rt.table_name = 'geonims'
                -- WHERE rg.geonim_type IN (${RKA.strTypes}) AND rg.id = ?
                WHERE rg.id = ?
                AND (rg.actual IS NULL OR (rg.actual <> 'false' AND rg.actual <> '0'))`, [ obj.street ])
        } else if(obj.city) {
            fullAddr = await db.execute(`SELECT
                    ra.id,
                    rt.title,
                    rt.short_title AS short_title,
                    ra.name_rus,
                    ra.full_path_rus,
                    ra.full_path_kaz,
                    ra.ats_type,
                    ra.rco
                FROM rka_ats ra
                JOIN rka_types rt ON ra.ats_type = rt.type_id AND rt.table_name = 'ats'
                WHERE ra.ats_type IN (${RKA.atsTypes}) AND ra.id = ?
                AND (ra.actual IS NULL OR (ra.actual <> 'false' AND ra.actual <> '0'))`, [ obj.city ])
        }
        fullAddr = fullAddr[0]

        return fullAddr
    }

    /**
     * checks if address exists in the table
     * if it doesn't, returns false
     * if exists:
     * * sets claim contact address, debt notice address, import contacts address, recipient address, user settings address, address visibility to existing address
     * * updates street names
     * * deletes old address
     * @param {Object} obj object with city id, street id, building id, apartment id, rca, and old address id
     * @returns 
     */
    async checkAddress(obj) {
        let {_city: city, _street: street, _building: building, _apartment: apartment, rca, oldAddress, extra } = obj
        let values = [ city.id, street.id, rca, 1 ]
        // let values = [ city.id, street.id, building.id, rca, 1 ]
        building = building?.id ?? null
        if(building) values.splice(2, 0, building)
        apartment = apartment?.id ?? null
        if(building && apartment) values.splice(3, 0, apartment)

        let [check] = await db.execute(`SELECT *
            FROM rka_addresses
            WHERE locality_id = ? AND
                street = ? AND
                ${ building ? 'building_number = ? AND' : '' }
                ${ apartment ? 'apartment = ? AND' : '' }
                rca = ? AND
                migrated = ?`, values)

        if(!check) return false

        let sql = ''

        // claim_contacts (set object_id to check.id where type = kazpost and object_id = oldAddress.id)
        let [contact] = await db.execute(`SELECT * FROM claim_contacts WHERE type = ? AND object_id = ?`, [ 'kazpost', oldAddress.id ])
        if(contact?.id) {
            await db.execute(`UPDATE claim_contacts SET object_id = ? WHERE id = ?`, [ check.id, contact.id ])
            sql += `UPDATE claim_contacts SET object_id = ${check.id} WHERE id = ${contact.id};\n`
        }

        // debt_notices (set address_id = check.id where address_id = oldAddress.id)
        await db.execute(`UPDATE debt_notices SET address_id = ? WHERE address_id = ?`, [ check.id, oldAddress.id ])
        sql += `UPDATE debt_notices SET address_id = ${check.id} WHERE address_id = ${oldAddress.id};\n`

        // import_contacts (set address = check.id where address = oldAddress.id)
        await db.execute(`UPDATE import_contacts SET address = ? WHERE address = ?`, [ check.id, oldAddress.id ])
        sql += `UPDATE import_contacts SET address = ${check.id} WHERE address = ${oldAddress.id};\n`

        // recipients_addresses (set address_id = check.id where address_id = oldAddress.id)
        await db.execute(`UPDATE recipients_addresses SET address_id = ?, extra = ? WHERE address_id = ?`, [ check.id, extra ?? null, oldAddress.id])
        sql += `UPDATE recipients_addresses SET address_id = ${check.id}, extra = ${sqlValue(extra)} WHERE address_id = ${oldAddress.id};\n`
        
        // user_settings (set value = check.id where key = 'address_id' and value = oldAddress.id)
        await db.execute(`UPDATE user_settings SET \`value\` = ? WHERE \`key\` = ? AND \`value\` = ?`, [ check.id, 'address_id', oldAddress.id])
        sql += `UPDATE user_settings SET \`value\` = ${check.id} WHERE \`key\` = 'address_id' AND \`value\` = ${oldAddress.id};\n`

        // users_addresses_visibility (set address_id = check.id where address_id = oldAddress.id)
        await db.execute(`UPDATE users_addresses_visibility SET address_id = ? WHERE address_id = ?`, [ check.id, oldAddress.id ])
        sql += `UPDATE users_addresses_visibility SET address_id = ${check.id} WHERE address_id = ${oldAddress.id};\n`

        // update other streets
        if(shouldUpdateOldStreetTitle(street, oldAddress)) {
            await db.execute(`SELECT title FROM rka_types WHERE table_name = 'geonims' AND type_id = ?`, [street.geonim_type])
            await db.execute(`UPDATE streets SET title = ? WHERE id = ?`, [ street.name_rus, oldAddress.street ])
            sql += `UPDATE streets SET title = '${street.name_rus}' WHERE id = ${oldAddress.street};\n`
        }
        await db.execute('UPDATE rka_addresses SET street = ? WHERE street = ?', [ street.id, check.street ])
        sql += `UPDATE rka_addresses SET street = '${street.id}' WHERE street = '${check.street}';\n`

        // delete from rka_addresses where id = oldAddress.id
        await db.execute(`DELETE FROM rka_addresses WHERE id = ?`, [oldAddress.id])
        sql += `DELETE FROM rka_addresses WHERE id = ${oldAddress.id};\n`

        // if(extra) await db.execute(`UPDATE recipients_addresses SET extra = ? WHERE address_id = ?`, [ extra, oldAddress.id ])

        await db.execute('UPDATE rka_addresses SET street = ? WHERE street = ?', [ street.id, check.street ])
        sql += `UPDATE rka_addresses SET street = '${street.id}' WHERE street = '${check.street}';\n`

        check.sql = sql
        return check
    }

    async deleteAddress(id, test = true) {
        if(!id) return false

        let address = await db.selectOne('rka_addresses', { filter: { id } })

        let check = await db.selectOne('rka_addresses', { filter: { locality_id: 0 }})

        let sql = ''
        if(!check) {
            await db.execute(`UPDATE rka_addresses SET locality_id = 0, street = '0', building_number = '0', apartment = '0', final_locality = 0, rca = '0', migrated = NULL WHERE id = ?`, [id])
            await db.execute(`DELETE FROM streets WHERE id = ?`, [address.street])
            await db.execute(`DELETE FROM recipients_addresses WHERE address_id = ?`, [id])
            await db.execute(`DELETE FROM user_settings WHERE \`key\` = ? AND \`value\` = ?`, [ 'address_id', id ])
            await db.execute(`DELETE FROM users_addresses_visibility WHERE address_id = ?`, [id])

            sql += `UPDATE rka_addresses SET locality_id = 0, street = '0', building_number = '0', apartment = '0', final_locality = 0, rca = '0', migrated = NULL WHERE id = ${id};\n`
            sql += `DELETE FROM streets WHERE id = ${address.street};\n`
            sql += `DELETE FROM recipients_addresses WHERE address_id = ${id};\n`
            sql += `DELETE FROM user_settings WHERE \`key\` = 'address_id' AND \`value\` = ${id};\n`
            sql += `DELETE FROM users_addresses_visibility WHERE address_id = ${id};\n`
            
            return { id, sql }
        }
        
        let [contact] = await db.execute(`SELECT * FROM claim_contacts WHERE type = ? AND object_id = ?`, [ 'kazpost', id ])
        if(test) {
            console.log('id', id)
            console.log('contact', contact)
            return { id, sql }
        }
        if(contact?.id) {
            await db.execute(`UPDATE claim_contacts SET object_id = ? WHERE id = ?`, [ check.id, contact.id ])
            sql += `UPDATE claim_contacts SET object_id = ${check.id} WHERE id = ${contact.id};\n`
        }
        await db.execute(`UPDATE debt_notices SET address_id = ? WHERE address_id = ?`, [ check.id, id ])
        await db.execute(`UPDATE import_contacts SET address = ? WHERE address = ?`, [ check.id, id ])
        await db.execute(`DELETE FROM recipients_addresses WHERE address_id = ?`, [id])
        await db.execute(`DELETE FROM user_settings WHERE \`key\` = ? AND \`value\` = ?`, [ 'address_id', id ])
        await db.execute(`DELETE FROM users_addresses_visibility WHERE address_id = ?`, [id])
        await db.execute(`DELETE FROM rka_addresses WHERE id = ?`, [id])

        sql += `UPDATE debt_notices SET address_id = ${check.id} WHERE address_id = ${id};\n`
        sql += `UPDATE import_contacts SET address = ${check.id} WHERE address = ${id};\n`
        sql += `DELETE FROM recipients_addresses WHERE address_id = ${id};\n`
        sql += `DELETE FROM user_settings WHERE \`key\` = 'address_id' AND \`value\` = ${id};\n`
        sql += `DELETE FROM users_addresses_visibility WHERE address_id = ${id};\n`
        sql += `DELETE FROM rka_addresses WHERE id = ${id};\n`

        console.log('deleted address', address)
        return {id, sql}
    }

    async archive(id) {
        if(!id) return false

        let address = await db.selectOne('rka_addresses', { filter: { id } })
        if(!address) return false

        await db.execute(`UPDATE rka_addresses SET migrated = ? WHERE id = ?`, [ 0, id])
        let sql = `UPDATE rka_addresses SET migrated = '0' WHERE id = ${id};\n`

        console.log('archived address', address)
        return { id, sql}
    }

    standardizeStreet(str) {
        if(!str) return ''

        return str.replace(/улица/gi, '')
        .replace(/улица /gi, '')
        .replace(/ул/gi, '')
        .replace(/ул./gi, '')
        .replace(/ул /gi, '')
        .replace(/ул. /gi, '')
        .replace(/проспект/gi, '')
        .replace(/проспект /gi, '')
        .replace(/пр/gi, '')
        .replace(/пр /gi, '')
        .replace(/пр./gi, '')
        .replace(/пр. /gi, '')
        .replace(/микрорайон/gi, '')
        .replace(/микрорайон /gi, '')
        .replace(/микр/gi, '')
        .replace(/микр./gi, '')
        .replace(/микр /gi, '')
        .replace(/микр. /gi, '')
        .replace(/мкр/gi, '')
        .replace(/мкр /gi, '')
        .replace(/мкр./gi, '')
        .replace(/мкр. /gi, '')
        .replace(/мкрн/gi, '')
        .replace(/мкрн /gi, '')
        .replace(/мкрн./gi, '')
        .replace(/мкрн. /gi, '')
        .replace(/переулок/gi, '')
        .replace(/переулок /gi, '')
        .replace(/пер/gi, '')
        .replace(/пер /gi, '')
        .replace(/пер./gi, '')
        .replace(/пер. /gi, '')
        .replace(/\s+/g, ' ')
        .trim()
    }

    static async findByRca(rca) {
        if(!rca || isNaN(rca) || String(rca).length !== 16) return false

        let [q] = await db.execute(`(SELECT
                id,
                number,
                full_path_rus,
                full_path_kaz,
                NULL as ats_id,
                building_id,
                NULL as geonim_id,
                NULL as ground_id,
                NULL as parent_id,
                actual,
                NULL as this_is,
                NULL as distance,
                modified,
                room_type,
                NULL as d_buildings_pointer_id,
                NULL as d_buildings_pointer_code,
                rca,
                NULL as parent_rca,
                source,
                last_updated
            FROM rka_building_parts
            WHERE rca = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0')))
            UNION ALL
            (SELECT
                id,
                number,
                full_path_rus,
                full_path_kaz,
                ats_id,
                NULL as building_id,
                geonim_id,
                ground_id,
                parent_id,
                actual,
                this_is,
                distance,
                modified,
                NULL as room_type,
                d_buildings_pointer_id,
                d_buildings_pointer_code,
                rca,
                parent_rca,
                source,
                last_updated
            FROM rka_buildings
            WHERE rca = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0')))
            LIMIT 1`, [ String(rca), String(rca)])

        return q ?? false
    }

    static async getLevels(rca) {
        if(!rca || isNaN(rca)) return false
        let result = {}

        let q = await BuildingPart.getByRka(rca)
        let city = null
        let str = null
        
        if(q) {
            result.apartment = `${q.title} ${q.number}`
            result.apartment_id = q.id
            let building = await Building.getById(q.building_id)
            str = building.geonim_id
            result.building_number = `${building.title} ${building.number}`
            result.building_id = building.id
        } else {
            result.apartment = ''
            q = await Building.getByRka(rca)
            if(q) {
                str = q.geonim_id
                if(q.parent_id) {
                    let parent = await Building.getById(q.parent_id)
                    if(parent) result.building_number = `${parent.title} ${parent.number}, ${q.title} ${q.number}`
                } else {
                    result.building_number = `${q.title} ${q.number}`
                    result.building_id = q.id
                }
            }
        }

        if(!q) return false

        let q2 = await Street.getById(str)
        if(q2) {
            city = q2.ats_id
            if(q2.parent_id) {
                let parent = await Street.getById(q.parent_id)
                if(parent) result.street = `${parent.title} ${parent.name_rus}, ${q2.title} ${q2.name_rus}`
            } else {
                result.street = `${q2.title} ${q2.name_rus}`
            }
            result.streetId = q2.id
        }

        let q3 = await City.getById(city)
        if(q3) {
            if(q3.parent_id) {
                let parent = await City.getById(q3.parent_id)
                if(parent) result.city = `${parent.title} ${parent.name_rus}, ${q3.title} ${q3.name_rus}`
            } else {
                result.street = `${q3.title} ${q3.name_rus}`
            }
            result.locality_id = q3.id
        }

        result.country = 'Казахстан'

        return result
    }

    static async findAddress(locality, street, building, room = false) {
        let cities = await db.execute(`SELECT * FROM rka_ats WHERE ats_type IN (1, 2, 4, 6, 9)`)
        let localityQuery = normalizeLocalityFuzzy(locality)
        if(!localityQuery) return false

        let scoredCity = cities.map(c => {
            return {
                city: c.name_rus,
                id: c.id,
                ats_type: c.ats_type,
                score: scoreLocality(localityQuery, c)
            }
        })

        scoredCity = scoredCity
            .filter(item => item.score >= 80)
            .sort((a, b) => {
                if(b.score !== a.score) return b.score - a.score

                return getLocalityTypePriority(b.ats_type) - getLocalityTypePriority(a.ats_type)
            })[0]

        if(!scoredCity) return false

        let atsIds = []
        atsIds.push(scoredCity.id)

        let cityChildren = await db.execute(`SELECT * FROM rka_ats WHERE ats_type IN (1, 2, 4, 5, 6, 8, 9) AND parent_id = ?`, [ scoredCity.id])
        
        cityChildren.forEach(c => {
            atsIds.push(c.id)
        })

        let streetQuery = normalizeStreetFuzzy(street)
        if(!streetQuery) return false

        let streets = await db.execute(`SELECT * FROM rka_geonims WHERE ats_id IN (${atsIds.join(', ')})`)

        let scoredStreet = streets.map(s => {
            return {
                street: s.name_rus,
                id: s.id,
                ats_id: s.ats_id,
                score: scoreStreet(streetQuery, s)
            }
        })

        scoredStreet = scoredStreet.filter(item => item.score >= 70).sort((a, b) => b.score - a.score)
        let scoredStreets = scoredStreet
        // let scoredStreets = scoredStreet.filter(item => item.street === scoredStreet[0].street)

        if(!scoredStreets.length) return false

        let buildings = await db.execute(`SELECT rb.*, rt.title, rt.short_title AS short_title
            FROM rka_buildings rb
            JOIN rka_types rt ON rb.d_buildings_pointer_id = rt.type_id AND rt.table_name = 'buildings'
            WHERE rb.geonim_id IN (${scoredStreets.map(i => i.id).join(', ')})
                AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))`)

        let scoredBuildings = buildings.map(b => {
            return {
                building: `${b.number}`,
                id: b.id,
                score: fuzzball.ratio(`${building}`.toLowerCase(), (`${b.number}`).toLowerCase())
            }
        })
        scoredBuildings = scoredBuildings.filter(item => item.score >= 70).sort((a, b) => b.score - a.score).slice(0, 50)
        scoredBuildings = scoredBuildings.map(b => {
            return {
                building: b.building,
                id: b.id,
                rka: b.rca,
                score: fuzzball.ratio(`${building}`.toLowerCase(), b.building.toLowerCase())
            }
        })

        scoredBuildings = scoredBuildings.filter(item => item.score >= 70).sort((a, b) => b.score - a.score).slice(0, 10)
        let scoredBuilding = scoredBuildings[0]

        if(!scoredBuilding) return false
        if(!room) return scoredBuilding.rka

        let parts = await db.execute(`SELECT rbp.*, rt.title, rt.short_title AS short_title
            FROM rka_building_parts rbp
            JOIN rka_types rt ON rbp.room_type = rt.type_id AND rt.table_name = 'building_parts'
            WHERE rbp.building_id = ?
            AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))`, [scoredBuilding.id])

        let scoredApt = parts.map(p => {
            return {
                apt: `${p.title} ${p.number}`,
                id: p.id,
                rka: p.rca,
                score: fuzzball.token_set_ratio(`${room}`.toLowerCase(), `${p.title} ${p.number}`.toLowerCase())
            }
        })

        scoredApt = scoredApt.filter(item => item.score >= 70).sort((a, b) => b.score - a.score)[0]
        if(!scoredApt) return scoredBuilding.rka
        return scoredApt.rka
    }
}

function normalizeCityText(value) {
    return String(value ?? '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
}

function getCityPathParts(city) {
    return String(city.full_path_rus ?? '')
        .split(',')
        .map(part => part.trim())
        .filter(Boolean)
}

function getCityBaseText(city) {
    if(city.ats_type == 4 || city.ats_type == 6 || city.ats_type == 9) return city.name_rus

    return [city.title?.trim(), city.name_rus].filter(Boolean).join(' ')
}

function isCityType(city) {
    return [4, 6, 9].includes(Number(city.ats_type))
}

function getCityRegionText(city) {
    return getCityPathParts(city)[1] ?? ''
}

function getCityDuplicateKey(city) {
    return [
        normalizeCityText(city.name_rus),
        normalizeCityText(getCityRegionText(city))
    ].join('|')
}

function getCityContextParts(city, includeDistricts = false) {
    const currentNames = new Set([
        normalizeCityText(city.name_rus),
        normalizeCityText(getCityBaseText(city))
    ])

    const pathParts = getCityPathParts(city)
        .slice(1)
        .filter(part => !currentNames.has(normalizeCityText(part)))

    if(includeDistricts) return pathParts

    return pathParts.slice(0, 1)
}

function prepareCities(cities = []) {
    const duplicateCounts = new Map()

    for(let city of cities) {
        const key = getCityDuplicateKey(city)

        if(!key.startsWith('|') && !key.endsWith('|')) {
            duplicateCounts.set(key, (duplicateCounts.get(key) || 0) + 1)
        }
    }

    let result = []

    for(let city of cities) {
        const duplicateInRegion = (duplicateCounts.get(getCityDuplicateKey(city)) || 0) > 1
        const contextParts = isCityType(city) ? [] : getCityContextParts(city, duplicateInRegion)
        city.text = [getCityBaseText(city), ...contextParts].filter(Boolean).join(', ')

        result.push(new City(city))
    }

    return result
}

class City {
    constructor(obj) {
        this.id = obj.id
        this.title = obj.title
        this.name_rus = obj.name_rus
        this.name_kaz = obj.name_kaz
        this.full_path_rus = obj.full_path_rus
        this.ats_type = obj.ats_type
        this.cato = obj.cato
        this.rco = obj.rco
        this.text = obj.text
    }

    static async all() {
        // get list of the cities
        let cities = await db.execute(`SELECT 
                ra.id,
                rt.title,
                rt.short_title AS short_title,
                ra.name_rus,
                ra.name_kaz,
                ra.full_path_rus,
                ra.full_path_kaz,
                ra.ats_type,
                ra.cato,
                ra.rco
            FROM rka_ats ra
            JOIN rka_types rt ON ra.ats_type = rt.type_id AND rt.table_name = 'ats'
            WHERE ra.ats_type IN (${RKA.atsTypes})
                AND ra.full_path_rus IS NOT NULL
                AND (ra.actual IS NULL OR (ra.actual <> 'false' AND ra.actual <> '0'))
            ORDER BY ra.parent_id, ra.name_rus`)

        return prepareCities(cities)
    }

    static async filter(filter, limit = 10) {
        let where = `
            ra.ats_type IN (${RKA.atsTypes})
            AND ra.full_path_rus IS NOT NULL
            AND (ra.actual IS NULL OR (ra.actual <> 'false' AND ra.actual <> '0'))
        `
    
        if (filter) {
            const like = `%${filter.trim()}%`

            where += ` AND (
                ra.name_rus LIKE '${like}'
                OR ra.name_kaz LIKE '${like}'
            )`
        }

        // get list of the cities
        let cities = await db.execute(`SELECT 
                ra.id,
                rt.title,
                rt.short_title AS short_title,
                ra.name_rus,
                ra.name_kaz,
                ra.full_path_rus,
                ra.full_path_kaz,
                ra.ats_type,
                ra.cato,
                ra.rco
            FROM rka_ats ra
            JOIN rka_types rt ON ra.ats_type = rt.type_id AND rt.table_name = 'ats'
            WHERE ${where}
            ORDER BY ra.parent_id, ra.name_rus
            LIMIT ${limit}`)

        if(!cities.length) return []

        return prepareCities(cities)
    }

    static async getById(id) {
        if(!id) return false

        let [q] = await db.execute(`SELECT ra.*, ra2.name_rus AS parent, rt2.title AS parent_title, rt2.short_title AS short_parent_title, rt.title, rt.short_title AS short_title FROM rka_ats ra JOIN rka_ats ra2 ON ra2.id = ra.parent_id JOIN rka_types rt ON rt.type_id = ra.ats_type AND rt.table_name = 'ats' JOIN rka_types rt2 ON rt2.type_id = ra2.ats_type AND rt2.table_name = 'ats' WHERE ra.id = ? AND (ra.actual IS NULL OR (ra.actual <> 'false' AND ra.actual <> '0'))`, [id])

        if(q) {
            q.text = `${q.parent ? `${q.parent_title} ${q.parent}, ` : ''} ${q.title} ${q.name_rus}`
        }

        return q ?? false
    }
}

function shouldUpdateOldStreetTitle(street, oldAddress) {
    const streetName = String(street?.name_rus ?? '').trim()

    return !!oldAddress?.street
        && !!street?.id
        && !!streetName
        && !/^\d+$/.test(streetName)
}

function normalizeStreetSearch(value) {
    return String(value ?? '')
        .replace(/&quot;/gi, '"')
        .replace(/[.,]/g, ' ')
        .replace(/(^|\s)(улица|ул|проспект|пр|микрорайон|микр|мкр|мкрн|переулок|пер)(?=\s|$)/giu, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}

function normalizeStreetFuzzy(value) {
    return normalizeStreetSearch(value)
        .toLowerCase()
        .replace(/[әáàâ]/gu, 'а')
        .replace(/[ёэ]/gu, 'е')
        .replace(/ғ/gu, 'г')
        .replace(/қ/gu, 'к')
        .replace(/ң/gu, 'н')
        .replace(/ө/gu, 'о')
        .replace(/[ұү]/gu, 'у')
        .replace(/һ/gu, 'х')
        .replace(/і/gu, 'и')
        .replace(/[^0-9a-zа-я\s"]/giu, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}

function formatStreetText(street) {
    const name = String(street.name_rus ?? '').replace(/&quot;/gi, '"')
    const prefix = street.parent && [84].includes(street.geonim_type)
        ? `${street.parent_title} ${street.parent}, `
        : ''

    return `${prefix}${street.title} ${name}`.trim()
}

function prepareStreet(street) {
    street.text = formatStreetText(street)
    street._searchTerms = getStreetSearchTerms(street)

    return street
}

function getStreetSearchTerms(street) {
    return [
        street.name_rus,
        street.name_kaz,
        street.text,
        `${street.title ?? ''} ${street.name_rus ?? ''}`,
        `${street.title ?? ''} ${street.name_kaz ?? ''}`,
        `${street.name_rus ?? ''} ${street.title ?? ''}`,
        `${street.name_kaz ?? ''} ${street.title ?? ''}`,
        `${street.parent_title ?? ''} ${street.parent ?? ''} ${street.title ?? ''} ${street.name_rus ?? ''}`
    ].map(normalizeStreetFuzzy).filter(Boolean)
}

function scoreStreet(query, street) {
    const terms = street._searchTerms ?? getStreetSearchTerms(street)

    return terms.reduce((best, term) => {
        const words = term.split(' ').filter(Boolean)

        if(term === query) return Math.max(best, 100)
        if(words.some(word => word.startsWith(query))) return Math.max(best, 98)
        if(query.length >= 4 && term.includes(query)) return Math.max(best, 95)

        return Math.max(best, fuzzball.token_set_ratio(query, term))
    }, 0)
}

function normalizeLocalityFuzzy(value) {
    return String(value ?? '')
        .replace(/[.,]/g, ' ')
        .replace(/(^|\s)(город|г|поселок|посёлок|п|село|с|аул|а)(?=\s|$)/giu, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/[әáàâ]/gu, 'а')
        .replace(/[ёэ]/gu, 'е')
        .replace(/ғ/gu, 'г')
        .replace(/қ/gu, 'к')
        .replace(/ң/gu, 'н')
        .replace(/ө/gu, 'о')
        .replace(/[ұү]/gu, 'у')
        .replace(/һ/gu, 'х')
        .replace(/і/gu, 'и')
        .replace(/[^0-9a-zа-я\s"]/giu, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}

function getLocalitySearchTerms(locality) {
    return [
        locality.name_rus,
        locality.name_kaz,
        `${locality.title ?? ''} ${locality.name_rus ?? ''}`,
        `${locality.title ?? ''} ${locality.name_kaz ?? ''}`,
        locality.full_path_rus,
        locality.full_path_kaz
    ].map(normalizeLocalityFuzzy).filter(Boolean)
}

function scoreLocality(query, locality) {
    const terms = getLocalitySearchTerms(locality)

    return terms.reduce((best, term) => {
        if(term === query) return Math.max(best, 100)
        if(query.length >= 4 && term.includes(query)) return Math.max(best, 95)

        return Math.max(best, fuzzball.token_set_ratio(query, term))
    }, 0)
}

function getLocalityTypePriority(atsType) {
    if(Number(atsType) === 1) return 5
    if(Number(atsType) === 2) return 4
    if(Number(atsType) === 4) return 3
    if(Number(atsType) === 6) return 2
    if(Number(atsType) === 9) return 1
    return 0
}

function getStreetScoreThreshold(query) {
    if(query.length <= 2) return 85
    if(query.length <= 4) return 80

    return 70
}

class Street {
    static filterCache = new Map()
    static filterCacheTtl = 5 * 60 * 1000

    constructor(obj) {
        this.id = obj.id
        this.title = obj.title
        this.parent = obj.parent
        this.parent_title = obj.parent_title
        this.name_rus = obj.name_rus
        this.name_kaz = obj.name_kaz
        this.full_path_rus = obj.full_path_rus
        this.full_path_kaz = obj.full_path_kaz
        this.ats_id = obj.ats_id
        this.geonim_type = obj.geonim_type
        this.rco = obj.rco,
        this.text = obj.text
    }

    static async all(city) {
        let children = await db.execute('SELECT id FROM rka_ats WHERE parent_id = ?', [city])
        let atsIds = [+city]
        for(let ch of children) {
            atsIds.push(ch.id)
        }

        let streets = await db.execute(`SELECT
                rg.id,
                rt.title,
                rt.short_title AS short_title,
                rg2.name_rus AS parent,
                rt2.title AS parent_title,
                rt2.short_title AS short_parent_title,
                rg.name_rus,
                rg.name_kaz,
                rg.full_path_rus,
                rg.full_path_kaz,
                rg.ats_id,
                rg.geonim_type,
                rg.rco
            FROM rka_geonims rg
            LEFT JOIN rka_geonims rg2 ON rg.parent_id = rg2.id
            JOIN rka_types rt ON rg.geonim_type = rt.type_id AND rt.table_name = 'geonims'
            LEFT JOIN rka_types rt2 ON rg2.geonim_type = rt2.type_id AND rt.table_name = 'geonims'
            WHERE rg.ats_id IN (${atsIds.join(', ')})
            GROUP BY rg.geonim_type, rg.name_rus
            -- GROUP BY rg.geonim_type, rg.parent_id, rg.name_rus
            ORDER BY rg.name_rus`)

        let result = []

        for(let street of streets) {
            street.text = `${street.parent && [84].includes(street.geonim_type) ? `${street.parent_title} ${street.parent}, ` : ''}${street.title} ${street.name_rus}`

            const obj = new Street(street)
            
            result.push(obj)
        }

        return result
    }

    static async filter(filter, city = null, limit = 10) {
        if(!city) return []

        const candidateLimit = Number(limit) || 10
        const query = normalizeStreetFuzzy(filter)

        // The empty search is used immediately after selecting a city. Do not
        // load and prepare every street just to return the first ten options.
        if(!query) {
            const streets = await Street.getFilterPreview(city, candidateLimit)

            return streets.map(street => new Street(street))
        }

        const streets = await Street.getFilterCandidates(city)

        const threshold = getStreetScoreThreshold(query)

        return streets
            .map(street => ({ street, score: scoreStreet(query, street) }))
            .filter(item => item.score >= threshold)
            .sort((a, b) => {
                if(b.score !== a.score) return b.score - a.score

                return a.street.text.localeCompare(b.street.text, 'ru')
            })
            .slice(0, candidateLimit)
            .map(item => new Street(item.street))
    }

    static async getFilterPreview(city, limit = 10) {
        const atsIds = await Street.getFilterAtsIds(city)

        if(!atsIds.length) return []

        const streets = await db.execute(
            `SELECT
                rg.id,
                rt.title,
                rt.short_title AS short_title,
                rg2.name_rus AS parent,
                rt2.title AS parent_title,
                rt2.short_title AS short_parent_title,
                rg.name_rus,
                rg.name_kaz,
                rg.full_path_rus,
                rg.full_path_kaz,
                rg.ats_id,
                rg.geonim_type,
                rg.rco
            FROM rka_geonims rg
            LEFT JOIN rka_geonims rg2 ON rg.parent_id = rg2.id
            JOIN rka_types rt
                ON rg.geonim_type = rt.type_id
                AND rt.table_name = 'geonims'
            LEFT JOIN rka_types rt2
                ON rg2.geonim_type = rt2.type_id
                AND rt2.table_name = 'geonims'
            WHERE rg.ats_id IN (${atsIds.map(() => '?').join(', ')})
            GROUP BY rg.geonim_type, rg.name_rus
            ORDER BY rg.name_rus
            LIMIT ?`,
            [...atsIds, Number(limit) || 10]
        )

        return (streets ?? []).map(prepareStreet)
    }

    static async getFilterCandidates(city) {
        const cacheKey = String(city)
        const cached = Street.filterCache.get(cacheKey)

        if(cached && cached.expiresAt > Date.now()) return cached.streets

        const atsIds = await Street.getFilterAtsIds(city)

        if(!atsIds.length) return []

        const streets = await db.execute(
            `SELECT
                rg.id,
                rt.title,
                rt.short_title AS short_title,
                rg2.name_rus AS parent,
                rt2.title AS parent_title,
                rt2.short_title AS short_parent_title,
                rg.name_rus,
                rg.name_kaz,
                rg.full_path_rus,
                rg.full_path_kaz,
                rg.ats_id,
                rg.geonim_type,
                rg.rco
            FROM rka_geonims rg
            LEFT JOIN rka_geonims rg2 ON rg.parent_id = rg2.id
            JOIN rka_types rt
                ON rg.geonim_type = rt.type_id
                AND rt.table_name = 'geonims'
            LEFT JOIN rka_types rt2
                ON rg2.geonim_type = rt2.type_id
                AND rt2.table_name = 'geonims'
            WHERE rg.ats_id IN (${atsIds.map(() => '?').join(', ')})
            GROUP BY rg.geonim_type, rg.name_rus
            ORDER BY rg.name_rus`,
            atsIds
        )

        const preparedStreets = (streets ?? []).map(prepareStreet)

        Street.filterCache.set(cacheKey, {
            streets: preparedStreets,
            expiresAt: Date.now() + Street.filterCacheTtl
        })

        return preparedStreets
    }

    static async getFilterAtsIds(city) {
        const children = await db.execute(
            'SELECT id FROM rka_ats WHERE parent_id = ?',
            [city]
        )

        const atsIds = [+city].filter(Boolean)

        for(const child of children ?? []) {
            atsIds.push(child.id)
        }

        return atsIds
    }

    static async getById(id) {
        if(!id) return false

        let [q] = await db.execute(`SELECT rg.*, rt.title, rt.short_title AS short_title FROM rka_geonims rg JOIN rka_types rt ON rt.type_id = rg.geonim_type AND rt.table_name = 'geonims' WHERE rg.id = ? AND (rg.actual IS NULL OR (rg.actual <> 'false' AND rg.actual <> '0'))`, [id])

        return q ?? false
    }
}

class Building {
    constructor(obj) {
        this.id = obj.id
        this.parent = obj.parent
        this.parent_title = obj.parent_title
        this.title = obj.title
        this.number = obj.number
        this.full_path_rus = obj.full_path_rus
        this.full_path_kaz = obj.full_path_kaz
        this.geonim_id = obj.geonim_id
        this.this_is = obj.this_is
        this.d_buildings_pointer_id = obj.d_buildings_pointer_id
        this.rca = obj.rca
        this.text = obj.text
    }

    static async all(city, street) {
        let [str] = await db.execute(`SELECT id, ats_id, geonim_type, name_rus FROM rka_geonims WHERE id = ? AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [ street])
        if(!str) {
            console.log('No street found')
            return []
        }
    
        let atsIds = []
    
        atsIds.push(+city)
    
        let cities2 = await db.execute(`SELECT id FROM rka_ats WHERE ats_type = '8' AND parent_id = (SELECT parent_id FROM rka_ats WHERE id = ?) AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [str.ats_id])
        for(let c of cities2) atsIds.push(c.id)

        let streetsIds = []
        let streets = await db.execute(`SELECT
                rg.id,
                rt.title,
                rt.short_title AS short_title,
                rg.name_rus,
                rg.name_kaz,
                rg.full_path_rus,
                rg.full_path_kaz,
                rg.ats_id,
                rg.geonim_type,
                rg.rco
            FROM rka_geonims rg
            JOIN rka_types rt ON rg.geonim_type = rt.type_id AND rt.table_name = 'geonims'
            WHERE
            -- WHERE rg.geonim_type IN (${RKA.strTypes}) AND
                rg.ats_id IN (${atsIds.join(', ')})
                ${str.geonim_type ? `AND rg.geonim_type = ${str.geonim_type}` : ''}
                AND rg.name_rus LIKE ?
                AND (rg.actual IS NULL OR (rg.actual <> 'false' AND rg.actual <> '0'))`, [`%${str.name_rus}%`])
        for(let street of streets) streetsIds.push(street.id)
    
        if(!streetsIds || !streetsIds.length) {
            console.log('No streets found')
            return []
        }
    
        let buildings = await db.execute(`SELECT
            rb.id,
            rb2.number AS parent,
            rt2.title AS parent_title,
            rt.title,
            rt.short_title AS short_title,
            rt2.short_title AS short_parent_title,
            rb.number,
            rb.full_path_rus,
            rb.full_path_kaz,
            rb.geonim_id,
            rb.this_is,
            rb.d_buildings_pointer_id,
            rb.rca
        FROM rka_buildings rb
        LEFT JOIN rka_buildings rb2 ON rb.parent_id = rb2.id
        JOIN rka_types rt ON rb.d_buildings_pointer_id = rt.type_id AND rt.table_name = 'buildings'
        LEFT JOIN rka_types rt2 ON rb2.d_buildings_pointer_id = rt2.type_id AND rt2.table_name = 'buildings'
        WHERE rb.d_buildings_pointer_id IN (${RKA.buildingTypes}) AND rb.geonim_id IN (${streetsIds})
        AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))
        ORDER BY rb.number + 0, rb.number`)
    
        if(!buildings?.length) {
            console.log('No buildings found')
            return []
        }
    
        let result = []

        for(let building of buildings) {
            if(building.this_is === 'corpus') building.title = 'корпус'
            if(building.this_is === 'block') building.title = 'блок'
            building.text = `${building.parent ? `${building.parent_title} ${building.parent}, ` : ''}${building.title} ${building.number}`

            const obj = new Building(building)

            result.push(obj)
        }
    
        return result
    }

    static async filter(city, street, building) {
        let [str] = await db.execute(`SELECT id, ats_id, name_rus FROM rka_geonims WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [ street])
        if(!str) {
            console.log('No street found')
            return []
        }

        let atsIds = []
        atsIds.push(+city)

        let cities = await db.execute(`SELECT id FROM rka_ats WHERE parent_id = (SELECT parent_id FROM rka_ats WHERE id = ?)
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [str.ats_id])

        for(let c of cities) atsIds.push(c.id)

        let streetsIds = []
        let streets = await db.execute(`SELECT rg.*
            FROM rka_geonims rg
            JOIN rka_types rt ON rg.geonim_type = rt.type_id AND rt.table_name = 'geonims'
            WHERE
                rg.ats_id IN (${atsIds.join(', ')})
                AND rg.name_rus LIKE ?
                AND (rg.actual IS NULL OR (rg.actual <> 'false' AND rg.actual <> '0'))
            ORDER BY rg.name_rus`, [`%${str.name_rus}%`])
        for(let street of streets) streetsIds.push(street.id)

        if(!streetsIds || !streetsIds.length) {
            console.log('No streets found')
            return []
        }

        let buildings = await db.execute(`SELECT
            rb.id,
            rb2.number AS parent,
            rt2.title AS parent_title,
            rt.title,
            rt2.short_title AS short_parent_title,
            rt.short_title AS short_title,
            rb.number,
            rb.this_is
        FROM rka_buildings rb
        LEFT JOIN rka_buildings rb2
            ON rb.parent_id = rb2.id
        JOIN rka_types rt
            ON rb.d_buildings_pointer_id = rt.type_id
            AND rt.table_name = 'buildings'
        LEFT JOIN rka_types rt2
            ON rb2.d_buildings_pointer_id = rt2.type_id
            AND rt2.table_name = 'buildings'
        WHERE
            CONCAT(rt.short_title, ' ', rb.number) LIKE ?
            AND rb.d_buildings_pointer_id IN (${RKA.buildingTypes})
            AND rb.geonim_id IN (${streetsIds})
            AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))
        ORDER BY rb.number + 0, rb.number
        LIMIT 10`, [`%${building}%`])

        if(!buildings?.length) {
            console.log('No buildings found (filter)')
            return []
        }

        let result = []

        for(let building of buildings) {
            if(building.this_is === 'corpus') building.title = 'корпус'
            if(building.this_is === 'block') building.title = 'блок'
            building.text = `${building.parent ? `${building.parent_title} ${building.parent}, ` : ''}${building.title} ${building.number}`

            const obj = new Building(building)

            result.push(obj)
        }

        return result
    }

    static async getByRka(rca) {
        if(!rca) return false

        let [q] = await db.execute(`SELECT rb.*, rt.title, rt.short_title AS short_title
            FROM rka_buildings rb
            JOIN rka_types rt ON rt.type_id = rb.d_buildings_pointer_id AND rt.table_name = 'buildings'
            WHERE rb.rca = ?
            AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0')) LIMIT 1`, [String(rca)])

        return q ?? false
    }

    static async getById(id) {
        if(!id) return false

        let [q] = await db.execute(`SELECT rb.*, rt.title, rt.short_title AS short_title
            FROM rka_buildings rb
            JOIN rka_types rt ON rt.type_id = rb.d_buildings_pointer_id AND rt.table_name = 'buildings'
            WHERE rb.id = ?
            AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))`, [id])

        return q ?? false
    }
}

class BuildingPart {
    constructor(obj) {
        this.id = obj.id
        this.title = obj.title
        this.number = obj.number
        this.full_path_rus = obj.full_path_rus
        this.full_path_kaz = obj.full_path_kaz
        this.building_id = obj.building_id
        this.room_type = obj.room_type
        this.rca = obj.rca
        this.text = obj.text
    }

    static async all(building) {
        let buildingParts = await db.execute(`SELECT
                rbp.id,
                rt.title,
                rt.short_title AS short_title,
                rbp.number,
                rbp.full_path_rus,
                rbp.full_path_kaz,
                rbp.building_id,
                rbp.room_type,
                rbp.rca
            FROM rka_building_parts rbp
            JOIN rka_types rt ON rbp.room_type = rt.type_id AND rt.table_name = 'building_parts'
            WHERE
                rbp.room_type IN (${RKA.roomTypes})
                AND rbp.building_id = ?
                AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))
            ORDER BY rt.title`, [ building ])

        let result = []
        for(let part of buildingParts) {
            part.text = `${part.title} ${part.number}`
            result.push(part)
        }

        return result
    }

    static async filter(building, filter = false) {
        if(!building) return false
        if(filter) filter = `%${filter}%`

        let buildingParts = await db.execute(`SELECT
                rbp.id,
                rt.title,
                rt.short_title AS short_title,
                rbp.number,
                rbp.full_path_rus,
                rbp.full_path_kaz,
                rbp.building_id,
                rbp.room_type,
                rbp.rca
            FROM rka_building_parts rbp
            JOIN rka_types rt ON rbp.room_type = rt.type_id AND rt.table_name = 'building_parts'
            WHERE
                ${ filter ? `CONCAT(rt.short_title, ' ', rbp.number) LIKE "${filter}" AND` : '' }
                rbp.room_type IN (${RKA.roomTypes}) AND
                rbp.building_id = ${building}
                AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))
            ORDER BY rt.title
            LIMIT 10`)

        let result = []
        for(let bp of buildingParts) {
            bp.text = `${bp.title} ${bp.number}`
            result.push(bp)
        }

        return result
    }

    static async getByRka(rca) {
        if(!rca) return false

        let [q] = await db.execute(`SELECT rbp.*, rt.title, rt.short_title AS short_title
            FROM rka_building_parts rbp
            JOIN rka_types rt ON rt.type_id = rbp.room_type AND rt.table_name = 'building_parts'
            WHERE rbp.rca = ? AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0')) LIMIT 1`, [String(rca)])

        return q ?? false
    }

    static async getById(id) {
        if(!id) return false

        let [q] = await db.execute(`SELECT rbp.*, rt.title, rt.short_title AS short_title
            FROM rka_building_parts rbp
            JOIN rka_types rt ON rt.type_id = rbp.room_type AND rt.table_name = 'building_parts'
            WHERE rbp.id = ?
            AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))`, [id])

        return q ?? false
    }
}

class Address {
    constructor(city, street = null, building = null, flat = null) {
        this.city = normalizeRkaId(city)
        this.street = normalizeRkaId(street)
        this.building = normalizeRkaId(building)
        this.flat = normalizeRkaApartmentId(flat)
    }

    init() {
        this.street = new Street()
    }

    async save() {
        if(!this.city || !this.street || !this.building) return false

        const params = [this.city, this.street, this.building]
        let sql = `SELECT *
            FROM rka_addresses
            WHERE locality_id = ?
                AND street = ?
                AND building_number = ?
                AND ${this.flat ? 'apartment = ?' : `(apartment IS NULL OR apartment = '' OR apartment = 'null' OR apartment = '0')`}
            LIMIT 1`

        if(this.flat) params.push(this.flat)

        let [check] = await db.execute(sql, params)

        if(check) return check.id

        const rca = await this.getRca()
        let saved = await db.execute(`INSERT INTO rka_addresses (locality_id, street, building_number, apartment, rca, migrated) VALUES (?, ?, ?, ?, ?, ?)`, [this.city, this.street, this.building, this.flat, rca, 1])

        return saved?.insertId ?? false
    }

    async getRca() {
        if(this.flat) {
            let [apartment] = await db.execute(`SELECT rca FROM rka_building_parts WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [this.flat])

            return apartment?.rca ?? null
        }

        if(this.building) {
            let [building] = await db.execute(`SELECT rca FROM rka_buildings WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [this.building])

            return building?.rca ?? null
        }

        return null
    }

    loadByRKA() {
    }

    loadByID() {
        // const a = RKA.get
    }
}

function normalizeRkaApartmentId(apartment) {
    if(apartment == null) return null

    const value = String(apartment).trim()

    if(value === '' || value === '0' || value.toLowerCase() === 'null') return null

    const number = Number(value)

    return Number.isNaN(number) ? null : number
}

function normalizeRkaId(id) {
    if(id == null) return null

    const value = String(id).trim()

    if(value === '' || value === '0' || value.toLowerCase() === 'null') return null

    return value
}

function getRkaId(...ids) {
    for(const id of ids) {
        const value = normalizeRkaId(id)

        if(value) return value
    }

    return null
}

/**
 * Builds the best available full display path for an address row.
 * Tries direct RKA path resolution first, then progressively weaker recovery
 * strategies for migrated or legacy address records.
 *
 * @param {object} address Address row or address-like object.
 * @param {?number} recipientId Recipient id used to append recipient-specific extra data.
 * @returns {Promise<?string>} Full display path or null when it cannot be resolved.
 */
async function getFullPath(address, recipientId = null) {
    if (!address) return null

    let fullAddress = await getAddressPathByParts(address)

    if(!fullAddress) fullAddress = await getRkaFullPathById(address)
    if(!fullAddress) fullAddress = await getRkaFullPathByRca(address)
    if(!fullAddress) fullAddress = await getRkaFullPathByNumber(address)
    if(!fullAddress) fullAddress = await getRkaFullPathByHierarchy(address)
    if(!fullAddress) fullAddress = await getLegacyFullPath(address)

    if (fullAddress) {
        let extra = recipientId ? await getAddressExtra(recipientId, address.id) : ''
        if(!hasAddressValue(extra)) extra = address.extra

        if (hasAddressValue(extra)) fullAddress += `, ${extra}`
    }

    return fullAddress ?? null
}

/**
 * Resolves an address path directly from RKA building/building-part ids.
 * Uses strict relation checks first, then relaxed lookups for migrated RKA rows.
 *
 * @param {object} address Address row or address-like object.
 * @returns {Promise<?string>} RKA full path or null when id-based lookup fails.
 */
async function getRkaFullPathById(address) {
    const partId = address.apartment ?? address.buildingPart
    const buildingId = address.building ?? address.building_number
    const streetId = address.street

    if (hasAddressValue(partId)) {
        const params = [partId]
        let sql = `SELECT full_path_rus FROM rka_building_parts WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`

        if(hasAddressValue(buildingId)) {
            sql += ` AND building_id = ?`
            params.push(buildingId)
        }

        const [part] = await db.execute(sql, params)
        if(part?.full_path_rus) return part.full_path_rus
    }

    if (hasAddressValue(buildingId)) {
        const params = [buildingId]
        let sql = `SELECT full_path_rus FROM rka_buildings WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`

        if(hasAddressValue(streetId)) {
            sql += ` AND geonim_id = ?`
            params.push(streetId)
        }

        const [building] = await db.execute(sql, params)
        if(building?.full_path_rus) return building.full_path_rus
    }

    if(!isRkaAddress(address)) return null

    if (hasAddressValue(partId)) {
        const [part] = await db.execute(`SELECT full_path_rus FROM rka_building_parts WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [partId])
        if(part?.full_path_rus) return part.full_path_rus
    }

    if (hasAddressValue(buildingId)) {
        const [building] = await db.execute(`SELECT full_path_rus FROM rka_buildings WHERE id = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))`, [buildingId])
        if(building?.full_path_rus) return building.full_path_rus
    }

    return null
}

/**
 * Resolves an address path from the RKA `rca` identifier.
 *
 * @param {object} address Address row or address-like object.
 * @returns {Promise<?string>} RKA full path or null when no matching RCA object exists.
 */
async function getRkaFullPathByRca(address) {
    if(!hasAddressValue(address.rca)) return null

    const [part] = await db.execute(`SELECT full_path_rus FROM rka_building_parts WHERE rca = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))
                LIMIT 1`, [String(address.rca)])
    if(part?.full_path_rus) return part.full_path_rus

    const [building] = await db.execute(`SELECT full_path_rus FROM rka_buildings WHERE rca = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))
                LIMIT 1`, [String(address.rca)])
    if(building?.full_path_rus) return building.full_path_rus

    return null
}

/**
 * Rebuilds an RKA path by matching a street id with building/apartment numbers.
 * This is used when the address row has usable numeric components but no direct path.
 *
 * @param {object} address Address row or address-like object.
 * @returns {Promise<?string>} RKA full path or null when numeric matching fails.
 */
async function getRkaFullPathByNumber(address) {
    const streetId = address.street
    const buildingNumber = address.building ?? address.building_number

    if(!hasAddressValue(streetId) || !hasAddressValue(buildingNumber)) return null

    const [building] = await db.execute(
        `SELECT id, full_path_rus
        FROM rka_buildings
        WHERE geonim_id = ? AND number = ?
            AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))
        ORDER BY id
        LIMIT 1`,
        [String(streetId), String(buildingNumber)]
    )

    if(!building?.id) return null

    const partNumber = address.apartment ?? address.buildingPart
    if(hasAddressValue(partNumber)) {
        const [part] = await db.execute(
            `SELECT full_path_rus
            FROM rka_building_parts
            WHERE building_id = ? AND number = ?
                AND (actual IS NULL OR (actual <> 'false' AND actual <> '0'))
            LIMIT 1`,
            [building.id, String(partNumber)]
        )

        if(part?.full_path_rus) return part.full_path_rus
    }

    return building.full_path_rus ?? null
}

/**
 * Reconstructs a full RKA address from related hierarchy objects
 * (`building part -> building -> street -> city`) when stored path fields are absent.
 *
 * @param {object} address Address row or address-like object.
 * @returns {Promise<?string>} Rebuilt full path or null when hierarchy recovery fails.
 */
async function getRkaFullPathByHierarchy(address) {
    if(!isRkaAddress(address)) return null

    const partId = address.apartment ?? address.buildingPart
    const buildingId = address.building ?? address.building_number

    let buildingPart = null
    let building = null

    if(hasAddressValue(partId)) {
        buildingPart = await BuildingPart.getById(partId)
        if(buildingPart?.full_path_rus) return buildingPart.full_path_rus
        if(buildingPart?.building_id) building = await Building.getById(buildingPart.building_id)
    }

    if(!building && hasAddressValue(buildingId)) {
        building = await Building.getById(buildingId)
        if(building?.full_path_rus) return building.full_path_rus
    }

    if(!building) return null

    const street = hasAddressValue(building.geonim_id) ? await Street.getById(building.geonim_id) : null
    const city = hasAddressValue(street?.ats_id) ? await City.getById(street.ats_id) : null

    const parts = [
        formatCityLabel(city),
        formatStreetLabel(street),
        formatBuildingLabel(building),
        formatBuildingPartLabel(buildingPart)
    ].filter(Boolean)

    return parts.length ? parts.join(', ') : null
}

/**
 * Formats an address from legacy locality/street/building fields when RKA recovery fails.
 * For migrated RKA-backed rows it still tries to resolve human-readable building labels.
 *
 * @param {object} address Address row or address-like object.
 * @returns {Promise<?string>} Legacy-style display path or null when nothing usable exists.
 */
async function getLegacyFullPath(address) {
    const localityId = address.final_locality || address.locality_id || address.city
    const buildingNumber = address.building_number ?? address.building
    const apartment = address.apartment ?? address.buildingPart
    const shouldResolveRkaLabels = isRkaAddress(address)

    const parts = []

    if(hasAddressValue(localityId)) {
        const [locality] = await db.execute(
            `SELECT l.title, lt.short
            FROM localities l
            LEFT JOIN locality_types lt ON lt.id = l.type_id
            WHERE l.id = ?
            LIMIT 1`,
            [localityId]
        )

        if(locality?.title) {
            const title = String(locality.title).trim()
            const short = String(locality.short || '').trim()

            parts.push(short && !title.toLowerCase().startsWith(short.toLowerCase()) ? `${short} ${title}` : title)
        }
    }

    if(hasAddressValue(address.street)) {
        const [street] = await db.execute(`SELECT title FROM streets WHERE id = ? LIMIT 1`, [address.street])
        if(street?.title) parts.push(street.title)
    }

    if(hasAddressValue(buildingNumber)) {
        const buildingText = shouldResolveRkaLabels ? await getRkaBuildingLabel(buildingNumber) : ''
        parts.push(buildingText || String(buildingNumber).trim())
    }

    if(hasAddressValue(apartment)) {
        const apartmentText = shouldResolveRkaLabels ? await getRkaBuildingPartLabel(apartment) : ''
        parts.push(apartmentText || String(apartment).trim())
    }

    return parts.length ? parts.join(', ') : null
}

/**
 * Resolves a human-readable building label from an RKA building id.
 *
 * @param {string|number} buildingId RKA building id.
 * @returns {Promise<string>} Building label or an empty string when it cannot be resolved.
 */
async function getRkaBuildingLabel(buildingId) {
    const [building] = await db.execute(
        `SELECT rb.number, rt.title, rt.short_title
        FROM rka_buildings rb
        LEFT JOIN rka_types rt ON rt.type_id = rb.d_buildings_pointer_id AND rt.table_name = 'buildings'
        WHERE rb.id = ?
        AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))
        LIMIT 1`,
        [buildingId]
    )

    if(!building?.number) return ''

    return [building.short_title || building.title, building.number].filter(Boolean).join(' ')
}

/**
 * Resolves a human-readable apartment/room label from an RKA building-part id.
 *
 * @param {string|number} buildingPartId RKA building-part id.
 * @returns {Promise<string>} Building-part label or an empty string when it cannot be resolved.
 */
async function getRkaBuildingPartLabel(buildingPartId) {
    const [buildingPart] = await db.execute(
        `SELECT rbp.number, rt.title, rt.short_title
        FROM rka_building_parts rbp
        LEFT JOIN rka_types rt ON rt.type_id = rbp.room_type AND rt.table_name = 'building_parts'
        WHERE rbp.id = ?
            AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))
        LIMIT 1`,
        [buildingPartId]
    )

    if(!buildingPart?.number) return ''

    return [buildingPart.short_title || buildingPart.title, buildingPart.number].filter(Boolean).join(' ')
}

function formatCityLabel(city) {
    if(!city) return ''

    return [
        city.parent ? formatRkaAddressPart(city.short_parent_title || city.parent_title, city.parent) : '',
        formatRkaAddressPart(city.short_title || city.title, city.name_rus) || city.name_rus
    ]
        .filter(Boolean)
        .join(', ')
}

function formatStreetLabel(street) {
    if(!street) return ''

    return [
        street.parent ? formatRkaAddressPart(street.short_parent_title || street.parent_title, street.parent) : '',
        formatRkaAddressPart(street.short_title || street.title, street.name_rus) || street.name_rus
    ]
        .filter(Boolean)
        .join(', ')
}

function formatBuildingLabel(building) {
    if(!building) return ''

    return [building.short_title || building.title, building.number].filter(Boolean).join(' ')
}

function formatBuildingPartLabel(buildingPart) {
    if(!buildingPart) return ''

    return [buildingPart.short_title || buildingPart.title, buildingPart.number].filter(Boolean).join(' ')
}

function isRkaAddress(address) {
    return String(address?.migrated) === '1' || hasAddressValue(address?.rca)
}

function hasAddressValue(value) {
    if(value == null) return false

    const normalized = String(value).trim().toLowerCase()

    return normalized !== '' && normalized !== '0' && normalized !== 'null'
}

/**
 * Get a building address using the same abbreviated RKA type names as profile addresses.
 *
 * @param {number|string} buildingId RKA building id
 * @returns {Promise<string|null>} Short building address
 */
async function getBuildingPath(buildingId) {
    const normalizedBuildingId = getRkaId(buildingId)
    if(!normalizedBuildingId) return null

    const [addressParts] = await db.execute(`SELECT
            COALESCE(parent.name_rus, town.name_rus) AS town_name,
            COALESCE(parent_type.title, town_type.title) AS town_title,
            COALESCE(parent_type.short_title, town_type.short_title) AS short_town_title,
            street.name_rus AS street_name,
            street_type.title AS street_title,
            street_type.short_title AS short_street_title,
            building.number AS building_number,
            building_type.title AS building_title,
            building_type.short_title AS short_building_title,
            building.full_path_rus
        FROM rka_buildings building
        JOIN rka_types building_type
            ON building_type.type_id = building.d_buildings_pointer_id
            AND building_type.table_name = 'buildings'
        JOIN rka_geonims street ON street.id = building.geonim_id
        JOIN rka_types street_type
            ON street_type.type_id = street.geonim_type
            AND street_type.table_name = 'geonims'
        JOIN rka_ats town ON town.id = street.ats_id
        JOIN rka_types town_type
            ON town_type.type_id = town.ats_type
            AND town_type.table_name = 'ats'
        LEFT JOIN rka_ats parent
            ON town.ats_type = 8
            AND parent.id = town.parent_id
            AND (parent.actual IS NULL OR (parent.actual <> 'false' AND parent.actual <> '0'))
        LEFT JOIN rka_types parent_type
            ON parent_type.type_id = parent.ats_type
            AND parent_type.table_name = 'ats'
        WHERE building.id = ?
            AND (building.actual IS NULL OR (building.actual <> 'false' AND building.actual <> '0'))
            AND (street.actual IS NULL OR (street.actual <> 'false' AND street.actual <> '0'))
            AND (town.actual IS NULL OR (town.actual <> 'false' AND town.actual <> '0'))
        LIMIT 1`, [normalizedBuildingId])

    if(!addressParts) return null

    return formatRkaAddressParts(addressParts) || addressParts.full_path_rus || null
}

async function getAddressPathByParts(address) {
    const townId = getRkaId(address.locality_id, address.city)
    const streetId = getRkaId(address.street)
    const buildingId = getRkaId(address.building_number, address.building)
    const apartmentId = getRkaId(address.apartment, address.buildingPart)

    if(!townId || !streetId || !buildingId) return null

    const [addressParts] = await db.execute(`SELECT
            town.title AS town_title,
            town.short_title AS short_town_title,
            town.name_rus AS town_name,
            street.title AS street_title,
            street.short_title AS short_street_title,
            street.name_rus AS street_name,
            building.title AS building_title,
            building.short_title AS short_building_title,
            building.number AS building_number,
            building_part.title AS apartment_title,
            building_part.short_title AS short_apartment_title,
            building_part.number AS apartment_number
        FROM (
            SELECT
                COALESCE(parent.name_rus, ra.name_rus) AS name_rus,
                COALESCE(parent_type.title, rt.title) AS title,
                COALESCE(parent_type.short_title, rt.short_title) AS short_title
            FROM rka_ats ra
            JOIN rka_types rt ON rt.type_id = ra.ats_type AND rt.table_name = 'ats'
            LEFT JOIN rka_ats parent ON ra.ats_type = 8 AND parent.id = ra.parent_id
            LEFT JOIN rka_types parent_type ON parent_type.type_id = parent.ats_type AND parent_type.table_name = 'ats'
            WHERE ra.id = ?
                AND (ra.actual IS NULL OR (ra.actual <> 'false' AND ra.actual <> '0'))
        ) town
        CROSS JOIN (
            SELECT rg.id, rg.name_rus, rt.title, rt.short_title
            FROM rka_geonims rg
            JOIN rka_types rt ON rt.type_id = rg.geonim_type AND rt.table_name = 'geonims'
            WHERE rg.id = ?
                AND (rg.actual IS NULL OR (rg.actual <> 'false' AND rg.actual <> '0'))
        ) street
        CROSS JOIN (
            SELECT rb.id, rb.number, rt.title, rt.short_title
            FROM rka_buildings rb
            JOIN rka_types rt ON rt.type_id = rb.d_buildings_pointer_id AND rt.table_name = 'buildings'
            WHERE rb.id = ?
                AND (rb.actual IS NULL OR (rb.actual <> 'false' AND rb.actual <> '0'))
        ) building
        LEFT JOIN (
            SELECT rbp.id, rbp.number, rt.title, rt.short_title
            FROM rka_building_parts rbp
            JOIN rka_types rt ON rt.type_id = rbp.room_type AND rt.table_name = 'building_parts'
            WHERE rbp.id = ?
                AND (rbp.actual IS NULL OR (rbp.actual <> 'false' AND rbp.actual <> '0'))
        ) building_part ON building_part.id = ?`, [townId, streetId, buildingId, apartmentId, apartmentId])

    if(!addressParts) return null

    return formatRkaAddressParts(addressParts)
}

function formatRkaAddressParts(addressParts) {
    return [
        formatRkaAddressPart(addressParts.short_town_title || addressParts.town_title, addressParts.town_name),
        formatRkaAddressPart(addressParts.short_street_title || addressParts.street_title, addressParts.street_name),
        formatRkaAddressPart(addressParts.short_building_title || addressParts.building_title, addressParts.building_number),
        formatRkaAddressPart(addressParts.short_apartment_title || addressParts.apartment_title, addressParts.apartment_number)
    ].filter(Boolean).join(', ')
}

function formatRkaAddressPart(title, name) {
    if(!title || !name) return null

    return `${title === 'г.' || title === 'г. обл. знач.' || title === 'г. р-н знач.' ? '' : title + ' '}${name}`.trim()
}

async function getAddressExtra(recipientId, addressId) {
    let [extra] = await db.execute(`SELECT * FROM recipients_addresses WHERE address_id = ? AND recipient_id = ?`, [ addressId, recipientId ])

    return extra?.extra ?? ''
}

module.exports = {
    RKA,
    Address,
    City,
    Street,
    Building,
    BuildingPart,
    getFullPath,
    getBuildingPath
}
